import React, { useState } from 'react';
// @ts-ignore
import styles from './CaseTypeOnlineOrdering.module.scss';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import CaseTypeOnlineOrderingScheduleModal from './CaseTypeOnlineOrderingScheduleModal';
import useLoading from '../../../../Base/Hooks/useLoading';
import CaseTypeOnlineOrderingServiceScheduleList from './CaseTypeOnlineOrderingServiceScheduleList/CaseTypeOnlineOrderingServiceScheduleList';
import useTranslation from '../../../../../Hooks/useTranslation';
import Text from '../../../../../Components/Base/Text/Text';
import LinkButton from '../../../../../Components/Button/LinkButton';

interface Props {
	workplaceId: string;
	caseTypeId: string;
	onSave: () => void;
	addIsOpen: boolean;
}

const CaseTypeOnlineOrdering: React.FC<Props> = ({
	workplaceId,
	caseTypeId,
	onSave,
	addIsOpen = false,
}) => {
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const { t } = useTranslation();
	const [isDetailOpen, setIsDetailOpen] = useState(addIsOpen);

	const handleOnServiceScheduleCreate = () => {
		setIsDetailOpen(false);
		setIsLoading(true);
		setTimeout(() => {
			setIsLoading(false);
		}, 500);
	};

	if (isLoading) {
		return <RenderLoading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.iconWrapper}>
				<img
					src='/dist/icons/triangle-exclamation-solid-full.svg'
					alt='warning'
					height='30px'
				/>
				<Text
					tx='component.onlineOrderingNotificationModal.title2'
					className={styles.bold}
				/>
			</div>
			<Text
				tx='component.onlineOrderingNotificationModal.text3'
				className='mt-3'
			/>
			<Button
				theme={Theme.GREEN}
				title='base.shared.continue'
				onClick={onSave}
				fitContent
				className='mt-3'
			/>
		</div>
	);

	/*
	return (
		<div className={styles.wrapper}>
			<CaseTypeOnlineOrderingServiceScheduleList
				workplaceId={workplaceId}
				caseTypeId={caseTypeId}
			/>
			<div className={styles.addButton} onClick={() => setIsDetailOpen(true)}>
				+ {t('component.caseTypeOnlineOrdering.addAnotherPeriod')}
			</div>
			<Button
				theme={Theme.GREEN}
				title='base.shared.save'
				onClick={onSave}
				fitContent
			/>
			{isDetailOpen && (
				<CaseTypeOnlineOrderingScheduleModal
					isOpen
					caseTypeId={caseTypeId}
					workplaceId={workplaceId}
					onClose={() => setIsDetailOpen(false)}
					onCreate={handleOnServiceScheduleCreate}
				/>
			)}
		</div>
	);
	 */
};

export default CaseTypeOnlineOrdering;
